import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { connect } from "react-redux";
import { getBlog } from "../../actions/blog_actions";
import { changeLoading } from "../../actions/loader_actions";
import BottomSheet from "../BottomSheet";
import Modal from "../Modal";
import { newsletterSignup } from "../../util/user_api_util";
import { readCookie, createCookie } from "../../helpers/cookie_helper";
import Trustbox from "../shared/Trustbox";

import TagCloud from "./TagCloud";

// import "../../styles/css/blog.css";

class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 5,
      email: "",
      expandedCategory: null,
      categoriesModalOpen: false,
      blogSearchModalOpen: false,
      blogSearch: ""
    };
  }

  componentDidMount = () => {
    this.props.changeLoading(true);
    if (this.props.match.params.tag) {
      let tag = this.props.match.params.tag;
      this.props
        .getBlog(this.state.quantity, tag)
        .then(import("../../styles/css/blog.css"));
    } else if (this.props.samples.length === 0) {
      this.props
        .getBlog(this.state.quantity)
        .then(import("../../styles/css/blog.css"));
    }
  };

  handleClick = () => {
    const quantity = this.state.quantity + 5;
    if (this.props.match.params.tag) {
      let tag = this.props.match.params.tag;
      this.props.getBlog(quantity, tag);
    } else {
      this.props.getBlog(quantity);
    }
    this.setState({ quantity });
  };

  validateEmail = email => {
    var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return re.test(String(email).toLowerCase());
  };

  injectTagCloud = (html, tagcloud, format) => {
    let newHtml = ReactHtmlParser(html, { transform: format });
    let post = newHtml[2];
    if (post && post.props.children[0].props.children) {
      let postBody = post.props.children[0].props.children;
      postBody.push(tagcloud);
    }
    return newHtml;
  };

  formatHtml = (html, tags) => {
    if (html) {
      const format = node => {
        if (node.type === "tag" && node.name === "a") {
          node.attribs.href = node.attribs.href.replace(
            "localhost",
            "localhost:3000"
          );
          node.attribs.href = node.attribs.href.replace(
            "fig-web",
            "figfrontend-web"
          );
          node.attribs.href = node.attribs.href.replace(
            "app.figloans.com",
            "figloans.com"
          );
        }
        if (node.type === "tag" && node.name === "img") {
          let imgPath = node.attribs.src.replace("/assets/", "");

          if (imgPath.indexOf("http") === -1) {
            let hexa = imgPath.slice(imgPath.indexOf("-"), imgPath.length - 4);
            imgPath = imgPath.replace(hexa, "");
            const src = `https://s3.us-west-2.amazonaws.com/figloans-static-images/${imgPath}`;
            this.ha = false;

            node.attribs.src = src;
          }
        }
      };
      if (tags) {
        return this.injectTagCloud(html, <TagCloud tags={tags} />, format);
      }
      return ReactHtmlParser(html, { transform: format });
    }
  };

  render() {
    // a true value for newsletterSignedUp means user has already signed up for the newsletter
    // if this is true do not render the BottomSheet modal to capture email address
    const newsletterSignedUp = readCookie("newsletter");

    const vw = window.innerWidth;

    const categorizedBlogs = this.props.allPosts
      ? this.props.allPosts
          .filter(x => x.category === this.state.expandedCategory)
          .sort((a, b) => {
            if (a.title < b.title) {
              return -1;
            }
            if (a.title > b.title) {
              return 1;
            }
            return 0;
          })
          .map(x => (
            <a href={`/blog/posts/${x.url}`}>
              <li>{x.title}</li>
            </a>
          ))
      : [];

    const categoryList = ["Loan Knowledge Center", "Community Resources and News", "Guides, Deals and Hacks", "Fig Chronicles", "Fig's Coverage on Covid", "Fig's Coverage on Hurricane Harvey"];

    const blogCategories = categoryList.map(category => {
      return (
        <span className="blog-category-expand">
          <p className="blog-category-name">{category}</p>{" "}
          <i
            className={`fas fa-caret-down fa-small ${this.state.expandedCategory === category ? null : "arrow-up"
              }`}
            onClick={e => {
              this.setState({
                expandedCategory:
                  this.state.expandedCategory === category ? null : category
              });
            }}
          ></i>
          {this.state.expandedCategory === category ? (
            <div className="categorized-blog-list">{categorizedBlogs}</div>
          ) : null}
        </span>
      )
    })        

    const categoriesContainer = (
      <div className="categories-container">
        <h3>Blog Categories</h3>
        {blogCategories}
      </div>
    );

    const searchResults =
      this.props.allPosts && this.state.blogSearch !== ""
        ? this.props.allPosts
            .filter(x =>
              x.title
                .toLowerCase()
                .includes(this.state.blogSearch.toLowerCase())
            )
            .map(x => <a href={`blog/posts/${x.url}`}>{x.title}</a>)
        : null;

    return (
      <div className="blog">
        <div className="container">
          <Helmet>
            <title>
              Making better financial decisions | A Fig a Day | Fig Loans
            </title>
            <link rel="canonical" href="https://www.figloans.com/blog" />
            <meta
              name="description"
              content="Giving you the know-how to compare financial products like loans and promoting best-in-class socially responsible products"
            />
            <meta
              property="og:description"
              content="Giving you the know-how to compare financial products like loans and promoting best-in-class socially responsible products"
            />
          </Helmet>
          <div className="panel-white">
            <div className="blog-about">
              <div className="blog-about-text">
                <h2 className="blog-name">
                  <Link
                    to="/blog"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    A Fig a Day, Keeps Bad Credit Away
                  </Link>
                </h2>
                <Trustbox size="small" />
              </div>
            </div>
          </div>
          <div className="panel-grey" id="blog-background">
            <div className="posts-and-categories-container">
              {vw <= 767
                ? [
                    <div
                      className="categories-button button primary"
                      onClick={() =>
                        this.setState({ categoriesModalOpen: true })
                      }
                    >
                      View Categories
                    </div>,

                    <div
                      className="blog-search-button button primary"
                      onClick={() =>
                        this.setState({ blogSearchModalOpen: true })
                      }
                    >
                      Search
                    </div>,

                    <Modal
                      open={this.state.categoriesModalOpen}
                      closeAction={() =>
                        this.setState({ categoriesModalOpen: false })
                      }
                    >
                      {categoriesContainer}
                    </Modal>,

                    <Modal
                      open={this.state.blogSearchModalOpen}
                      closeAction={() =>
                        this.setState({ blogSearchModalOpen: false })
                      }
                    >
                      <input
                        placeholder="Search Blog Posts"
                        className="blog-search-modal"
                        onChange={e =>
                          this.setState({ blogSearch: e.target.value.trim() })
                        }
                      />
                      {searchResults && searchResults.length > 0 ? (
                        <div className="search-results-modal">
                          {searchResults}
                        </div>
                      ) : null}
                    </Modal>
                  ]
                : null}
              <div className="categories-column">
                <input
                  placeholder="Search Blog Posts"
                  className="blog-search"
                  onChange={e =>
                    this.setState({ blogSearch: e.target.value.trim() })
                  }
                />
                {searchResults && searchResults.length > 0 ? (
                  <div className="search-results">{searchResults}</div>
                ) : null}
                {categoriesContainer}
              </div>
              <div id="post_container" className="post_container_preview">
                {this.props.samples.map(sample =>
                  this.formatHtml(sample.html, sample.tags)
                )}
              </div>
              <div className="categories-column"></div>
            </div>
            {this.props.samples.length < this.state.quantity ? (
              ""
            ) : (
              <div
                onClick={this.handleClick}
                className="pseudo_submit button primary"
                style={{ width: "30%" }}
              >
                See More
              </div>
            )}
            <br />
            <section
              className="section-panel bg-white"
              id="section-testimonials"
            >
              <div className="content-container">
                <div className="content">
                  <h2 style={{ textAlign: "center", width: "100%" }}>
                    Check out our reviews!
                  </h2>
                  <Trustbox />
                </div>
              </div>
            </section>
          </div>
        </div>
        {newsletterSignedUp ? null : (
          <BottomSheet thankYou={this.state.thankYou} triggerOnScroll={true}>
            {this.state.thankYou ? (
              <div className="thank-you-text-and-img">
                <div className="fig-and-thanks">
                  <img
                    alt="lavander fig"
                    src="data:image/png;base64,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"
                  />
                  <h3>Thank you!</h3>
                </div>
                <p>
                  Learn more about <a href="/what-is-fig">Fig Loans</a>
                </p>
              </div>
            ) : (
              <div className="email-capture">
                <h3>
                  Get updates from <b className="green">Fig!</b>
                </h3>
                <input
                  type="text"
                  placeholder="Enter email"
                  onChange={e => {
                    this.setState({ email: e.target.value });
                  }}
                />
                <div
                  className="button"
                  onClick={() => {
                    if (this.validateEmail(this.state.email.trim())) {
                      newsletterSignup(this.state.email.trim())
                        .then(success => {
                          this.setState({ thankYou: true });
                          setTimeout(() => {
                            createCookie("newsletter", "true");
                          }, 1000);
                        })
                        .catch(error => {
                          alert(error.errors[0]);
                        });
                    } else {
                      alert("Please enter a valid email address.");
                    }
                  }}
                >
                  Subscribe
                </div>
                <p style={{ textAlign: "center" }}>
                  Subscribe to our newsletter to receive more personal finance
                  insights, as well as special offers on Fig Loans. See our
                  privacy policy <a href="/privacy">here</a>!
                </p>
              </div>
            )}
          </BottomSheet>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  samples: state.entities.blog.samples,
  allPosts: state.entities.blog.allPosts,
  errors: Object.values(state.errors.blog)
});

const mapDispatchToProps = dispatch => ({
  getBlog: (quantity, tag = null) => dispatch(getBlog(quantity, tag)),
  changeLoading: loadingState => dispatch(changeLoading(loadingState))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Blog)
);
